import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
// import reportWebVitals from "./reportWebVitals"
import { ConfigProvider, theme } from 'antd'
import 'antd/dist/reset.css' // 或者使用 'antd/dist/antd.css'
import './index.css'
import './style.scss'
import { defaultTheme } from './theme'
import en_GB from 'antd/locale/en_GB'
import { HashRouter } from 'react-router-dom'
import { MessageProvider } from './hooks/useMessage'
import Loading from './components/Loading'
import { I18nextProvider } from 'react-i18next'
import i18next from 'i18next'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  // <React.StrictMode>
  <I18nextProvider i18n={i18next}>
    <ConfigProvider locale={en_GB} theme={defaultTheme}>
      <MessageProvider>
        <Loading />
        <HashRouter>
          <App />
        </HashRouter>
      </MessageProvider>
    </ConfigProvider>
  </I18nextProvider>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
